import { useEffect, useState } from "react";
import blogApi from "../services/blogApi";
import categories from "../config/categories.json";

export const useArticles = (CategoryslugFromState, page = 1) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categoryId, setCategoryId] = useState();
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const fetchArticles = async () => {
      setLoading(true);

      const categoryId = categories.find(cat => cat.slug === CategoryslugFromState)?.id;
      setCategoryId(categoryId);

      if (!categoryId) {
        setPosts([]);
        setLoading(false);
        return;
      }

      try {
        const response = await blogApi.getCategorizedBlogPosts(categoryId, page);
        const posts = Array.isArray(response?.data) ? response.data : [];

        const headers = response?.headers || {};
        const totalPagesHeader =
          headers["x-wp-totalpages"] || headers["X-WP-TotalPages"];
        const wpTotalPages = totalPagesHeader ? parseInt(totalPagesHeader, 10) : 1;

        setTotalPages(wpTotalPages);
        setPosts(posts || []);
      } catch (error) {
        console.error("Failed to fetch posts:", error);
        setPosts([]);
      }

      setLoading(false);
    };

    fetchArticles();
  }, [CategoryslugFromState, page]);

  return { posts, loading, categoryId, totalPages };
};
